module.exports = __webpack_public_path__ + "img/Multimedia & Technik.7fa02136.jpg";